import React from "react";
import { Alert, Button } from "react-bootstrap";

export default function RejectionApprovalNotice({ approval, onRefresh }) {
  if (!approval) return null;

  return (
    <Alert
      variant={
        approval.status === "Pending"
          ? "warning"
          : approval.status === "Approved"
            ? "success"
            : "danger"
      }
      className="p-2"
    >
      <div className="d-flex justify-content-between align-items-center gap-3">
        <div className="flex-grow-1">
          <div>
            <strong>
              Rejection {approval.status.toLowerCase()}:{" "}
              {approval.actualQuantity} pieces.
            </strong>{" "}
            {approval.status === "Pending"
              ? "A different authorized user must review this request on the Rejection Approval page. Confirmation and Close Jobcard are blocked until a decision is made."
              : approval.status === "Revoked"
                ? "Only this request's rejection quantities were reversed. Previously approved quantities are preserved. You can enter corrected quantities and confirm again."
                : "Rejection approved. Close Jobcard is available once all quantities are confirmed."}
          </div>

          {approval.comments && (
            <div>
              <b>Comments:</b> {approval.comments}
            </div>
          )}
        </div>

        <Button
          size="sm"
          variant="outline-secondary"
          onClick={onRefresh}
          className="flex-shrink-0"
        >
          <i className="bi bi-arrow-clockwise me-1"></i>
          Refresh
        </Button>
      </div>
    </Alert>
  );
}
